export type Gender = "unspecified" | "female" | "male";
export type AgeCategory = "unspecified" | "70+" | "65-69" | "60-64" | "55-59" | "50-54" | "45-49" | "40-44" | "18-39";

export const GENDER_OPTIONS: { value: Gender; label: string }[] = [
  { value: "unspecified", label: "Wolę nie podawać" },
  { value: "female", label: "Kobieta" },
  { value: "male", label: "Mężczyzna" }
];

export const AGE_CATEGORY_OPTIONS: { value: AgeCategory; label: string }[] = [
  { value: "unspecified", label: "Wolę nie podawać" },
  { value: "70+", label: "70+" },
  { value: "65-69", label: "65-69" },
  { value: "60-64", label: "60-64" },
  { value: "55-59", label: "55-59" },
  { value: "50-54", label: "50-54" },
  { value: "45-49", label: "45-49" },
  { value: "40-44", label: "40-44" },
  { value: "18-39", label: "18-39" }
];

export type HeadphoneType = "unspecified" | "in-ear" | "over-ear";

export const HEADPHONE_TYPE_OPTIONS: { value: HeadphoneType; label: string }[] = [
  { value: "unspecified", label: "Wolę nie podawać" },
  { value: "in-ear", label: "Douszne" },
  { value: "over-ear", label: "Nauszne" }
];

export type HeadphoneConnection = "unspecified" | "wired" | "wireless";

export const HEADPHONE_CONNECTION_OPTIONS: { value: HeadphoneConnection; label: string }[] = [
  { value: "unspecified", label: "Wolę nie podawać" },
  { value: "wired", label: "Przewodowe" },
  { value: "wireless", label: "Bezprzewodowe" }
];
